// Dates, times and lengths as the boards write them, always in UK time. Month and day names are
// spelt out here rather than left to the browser, which writes "Sept" in some versions.
const TZ = 'Europe/London'
const DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
const DAYS3 = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
const MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
const MONTHS3 = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

const parts = new Intl.DateTimeFormat('en-GB', {
  timeZone: TZ, year: 'numeric', month: 'numeric', day: 'numeric',
  hour: 'numeric', minute: 'numeric', hourCycle: 'h23',
})

// A moment in UK time: { y, m (1 to 12), d, hh, mm, dow (0 is Sunday), day (a day number to compare) }
export function uk(t) {
  const o = {}
  for (const p of parts.formatToParts(new Date(t))) o[p.type] = p.value
  const y = +o.year, m = +o.month, d = +o.day
  const utc = Date.UTC(y, m - 1, d)
  return { y, m, d, hh: +o.hour % 24, mm: +o.minute, dow: new Date(utc).getUTCDay(), day: utc / 86400000 }
}

// A calendar date with no time ('2026-10-21'), as the database keeps starts_on and paused_until
export function calendarDay(s) {
  const [y, m, d] = String(s).split('-').map(Number)
  const utc = Date.UTC(y, m - 1, d)
  return { y, m, d, hh: 0, mm: 0, dow: new Date(utc).getUTCDay(), day: utc / 86400000 }
}

const at = t => (t && typeof t === 'object' && 'day' in t ? t : uk(t))

// 7pm, 6:45pm, 12pm
export function time(t) {
  const { hh, mm } = at(t)
  return (hh % 12 || 12) + (mm ? ':' + String(mm).padStart(2, '0') : '') + (hh < 12 ? 'am' : 'pm')
}
// Wednesday 30 September
export function longDate(t) { const u = at(t); return `${DAYS[u.dow]} ${u.d} ${MONTHS[u.m - 1]}` }
// Mon 28 Sep
export function shortDate(t) { const u = at(t); return `${DAYS3[u.dow]} ${u.d} ${MONTHS3[u.m - 1]}` }
// 2 Oct
export function dayMonth(t) { const u = at(t); return `${u.d} ${MONTHS3[u.m - 1]}` }
// 25 September
export function dayMonthLong(t) { const u = at(t); return `${u.d} ${MONTHS[u.m - 1]}` }
// Thursday
export function weekday(t) { return DAYS[at(t).dow] }
// The date blocks on Coming up and Free webinars: WED, 30, SEP
export function dateBlock(t) {
  const u = at(t)
  return { dow: DAYS3[u.dow].toUpperCase(), day: String(u.d), mon: MONTHS3[u.m - 1].toUpperCase() }
}

// 0 today, 1 tomorrow, -1 yesterday, in UK days
export function daysFrom(nowMs, t) { return at(t).day - uk(nowMs).day }

// Morning before midday, then afternoon, then evening from 5pm
export function greetingWord(nowMs) {
  const { hh } = uk(nowMs)
  return hh < 12 ? 'Morning' : hh < 17 ? 'Afternoon' : 'Evening'
}

const plural = (n, word) => `${n} ${word}${n === 1 ? '' : 's'}`

// 1 hour 48 minutes
export function duration(seconds) {
  const total = Math.round((seconds || 0) / 60)
  const h = Math.floor(total / 60), m = total % 60
  if (!h) return plural(m, 'minute')
  return m ? `${plural(h, 'hour')} ${plural(m, 'minute')}` : plural(h, 'hour')
}
export function minutes(n) { return plural(n, 'minute') }

// Carry on from 52:10, or 1:02:09 past the hour
export function clock(seconds) {
  const s = Math.max(0, Math.floor(seconds || 0))
  const h = Math.floor(s / 3600), m = Math.floor((s % 3600) / 60), r = s % 60
  const ss = String(r).padStart(2, '0')
  return h ? `${h}:${String(m).padStart(2, '0')}:${ss}` : `${m}:${ss}`
}

// A chapter's place in a recording, as search shows it: 08:51, 01:16:30
export function stamp(seconds) {
  const s = Math.max(0, Math.floor(seconds || 0))
  const h = Math.floor(s / 3600), m = Math.floor((s % 3600) / 60), r = s % 60
  const p = n => String(n).padStart(2, '0')
  return h ? `${p(h)}:${p(m)}:${p(r)}` : `${p(m)}:${p(r)}`
}

// Initials for the account button: Sam Carter -> SC
export function initials(name) {
  const words = String(name || '').trim().split(/\s+/).filter(Boolean)
  if (!words.length) return ''
  const first = words[0][0], last = words.length > 1 ? words[words.length - 1][0] : ''
  return (first + last).toUpperCase()
}

// Square brackets mark a value still to come, so it's never shown to a member as if it were real
export function isPlaceholder(s) {
  return !s || /^\[.*\]$/.test(String(s).trim())
}
